import gql from 'graphql-tag';

import { CONTENT_FIELDS } from 'apps/content/gql';

export const INITIATIVE_FIELDS = gql`
  ${CONTENT_FIELDS}
  fragment initiativeFields on Initiative {
    id
    canUpdate
    canDelete
    slug
    avatar {
      id
      path
      url
      filename
      completed
    }
    imageFallbackChar
    inSpace {
      id
      whichTypes
    }
    title
    description
    content {
      ...contentFields
    }
    socialAccounts {
      id
      accountType
      accountName
    }
    tags {
      id
      name
    }
    projectsCount
    storiesCount
    threadsCount
    forum {
      id
    }
  }
`;

export const INITIATIVE_LIST_FIELDS = gql`
  fragment initiativeListFields on Initiative {
    id
    slug
    avatar {
      id
      path
      url
      completed
    }
    imageFallbackChar
    title
    description
    content {
      id
      isFollowed
      whitelabel
      creator {
        id
        username
      }
    }
  }
`;

export const INITIATIVE_CONNECTION_FIELDS = gql`
  ${INITIATIVE_LIST_FIELDS}
  fragment initiativeConnectionFields on InitiativeConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        ...initiativeListFields
      }
    }
  }
`;

// TODO: Check if re-defining this here still needed to break circular import...
export const PROFILE_FIELDS = gql`
  fragment pConnectionFields on ProfileConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        fullName
        username
        imageFallbackChar
        avatar {
          id
          path
          url
          completed
        }
        bio
        content {
          ...contentFields
        }
      }
    }
  }
`;
